import { RecurrentDescriptionV2 } from './components/RecurrentDescriptionV2/RecurrentDescriptionV2'
import { ReactComponent as ShieldTick } from '../../../../icons/shieldTick.svg'
import { getCurrencySymbol } from '../../../../utils/getCurrencySymbol'
import { FormButtonV2 } from './components/FormButtonV2/FormButtonV2'
import { PromocodeV2 } from './components/PromocodeV2/PromocodeV2'
import { Checkboxes } from './components/Checkboxes/Checkboxes'
import React, { useMemo, useState } from 'react'
import styles from './PayDetails.module.scss'

export const PayDetails = ({
  price,
  currency,
  products,
  promoRes,
  result,
  card_save_status,
  setCard_save_status,
  countSalesStatus,
  accept_license,
  accept_oferta,
  accept_adv,
  setAccept_license,
  setAccept_oferta,
  setAccept_adv,
  countSalesLink,
  inputsError,
  promoEr,
  bindingProduct,
  isLoading,
  limitSalesStatus,
  handleSubmit,
  setPromoRes,
  checkedProducts,
  promocode,
  setPromocode,
  setPromocode_id,
  setPromoEr,
  payment_method_id,
  checkedProductsParams,
  durationErr,
  countSalesError
}) => {
  const [checkboxesError, setCheckboxesError] = useState({
    accept_license: false,
    accept_oferta: false
  })

  const recStatus = result?.recurrent_status ?? false
  const promocode_status = result?.promocode_status

  const btnDisabled = useMemo(() => {
    if (
      Object.values(inputsError).some((value) => value === true) ||
      !price ||
      promoEr ||
      isLoading ||
      Object.values(checkboxesError).some((value) => value === true) ||
      !payment_method_id ||
      durationErr
    ) {
      return true
    }
    return false
  }, [
    inputsError,
    price,
    promoEr,
    isLoading,
    checkboxesError,
    payment_method_id,
    durationErr
  ])

  return (
    <div className={styles.root} data-testid="payDetails-root">
      <div className={styles.title} data-testid="payDetails-title">
        Ваш заказ
      </div>

      <div className={styles.detailsBox} data-testid="payDetails-detailsBox">
        <div
          className={styles.detailsLeft}
          data-testid="payDetails-detailsLeft"
        >
          Товары, {products?.length} шт.
        </div>
        <div
          className={styles.detailsRight}
          data-testid="payDetails-detailsRight"
        >
          {price?.toLocaleString('ru-RU')}
          {getCurrencySymbol(currency) || '₽'}
        </div>
      </div>

      {promocode_status && (
        <PromocodeV2
          promoRes={promoRes}
          setPromoRes={setPromoRes}
          checkedProducts={checkedProducts || checkedProductsParams}
          promocode={promocode}
          setPromocode={setPromocode}
          setPromocode_id={setPromocode_id}
          setPromoEr={setPromoEr}
          payment_method_id={payment_method_id}
          currency={currency}
        />
      )}

      <div className={styles.sumBox} data-testid="payDetails-sumBox">
        <div className={styles.sumLeft} data-testid="payDetails-sumLeft">
          Итого:
        </div>
        <div className={styles.sumRight} data-testid="payDetails-sumRight">
          {price?.toLocaleString('ru-RU')}
          {getCurrencySymbol(currency) || '₽'}
        </div>
      </div>

      {recStatus && (
        <RecurrentDescriptionV2
          result={result}
          countSalesStatus={countSalesStatus}
          currency={currency}
        />
      )}

      <div data-testid="divider" className={styles.divider} />

      <Checkboxes
        result={result}
        card_save_status={card_save_status}
        setCard_save_status={setCard_save_status}
        countSalesStatus={countSalesStatus}
        accept_license={accept_license}
        accept_oferta={accept_oferta}
        accept_adv={accept_adv}
        setAccept_license={setAccept_license}
        setAccept_oferta={setAccept_oferta}
        setAccept_adv={setAccept_adv}
        checkboxesError={checkboxesError}
        setCheckboxesError={setCheckboxesError}
      />

      {countSalesStatus && (
        <div
          data-testid="count-error-message"
          className={styles.countSalesError}
        >
          {countSalesError}
        </div>
      )}

      <FormButtonV2
        countSalesStatus={countSalesStatus}
        countSalesLink={countSalesLink}
        bindingProduct={bindingProduct}
        isLoading={isLoading}
        limitSalesStatus={limitSalesStatus}
        handleSubmit={handleSubmit}
        setCheckboxesError={setCheckboxesError}
        accept_license={accept_license}
        accept_oferta={accept_oferta}
        btnDisabled={btnDisabled}
      />

      {recStatus && (
        <div data-testid="recDescBox" className={styles.recDescBox}>
          <ShieldTick />
          <div data-testid="recDesc" className={styles.recDesc}>
            <span>
              Платёж защищен. Данные вашей карты сохраняются при оплате.{' '}
            </span>
            <a
              href={'https://sites.profinansy.ru/subscription'}
              target="_blank"
            >
              Подробнее
            </a>
          </div>
        </div>
      )}
    </div>
  )
}
